import type {MoreQuestionsProps} from "./parts/more-questions/more-questions";

/**
 * Static FAQ "More Questions" data with translations
 */
export const faqMoreQuestionsData: Record<"en" | "es", MoreQuestionsProps> = {
    en: {
        title: "More questions?",
        description: "Feel free to send us an email with any and all questions you might have regarding the start of a Casago Franchise!",
        do_text: "We'd love to help answer your questions!",
        button: {
            text: "Shoot a Direct Mail",
            href: "/contact",
        },
    },
    es: {
        title: "¿Más preguntas?",
        description:
            "¡No dude en enviarnos un correo electrónico con todas las preguntas que pueda tener sobre el inicio de una franquicia de Casago!",
        do_text: "¡Nos encantaría ayudarte a responder tus preguntas!",
        button: {
            text: "Enviar un correo directo",
            href: "/contact",
        },
    },
};
